<template>
  <div class="p-collab-hub">
    <page-title>Collaboration Hub</page-title>

    <tabs>
      <tabs-item :key="tabs.indexOf(tab)" v-for="tab in tabs" :link="tab.to">{{
        tab.title
      }}</tabs-item>
    </tabs>

    <loading v-if="loading"></loading>

    <section-block v-else>
      <template slot="header">
        <filter-bar
          showSearch
          showSort
          showFilter
          resource="Questions"
          :filterOptions="interestGroups"
          :sortOptions="sortOptions"
          class="sm-margin-neg"
          filter-url-param="interestgroups"
          v-if="interestGroups"
        >
          <span class="u-hide-tablet">
            <base-button
              @click="showMoreFilters = !showMoreFilters"
              class="u-hide-mobile no-word-break"
            >
              More
              <span class="u-hide-tablet">...</span>
            </base-button>
          </span>
        </filter-bar>
        <div
          :class="{ 'is-shown': showMoreFilters }"
          class="p-collab-hub__extra"
        >
          <p>
            <form-toggle
              v-model="showClosed"
              @toggle="showClosed = !showClosed"
              label="Show Closed Questions?"
            />
          </p>
        </div>
      </template>
      <template slot="actions">
        <base-button
          v-if="UserHasPermission"
          @click="$router.push({ name: 'QuestionCreate' })"
          iconBefore="pencil"
          :primary="true"
          class="submit-button"
        >
          Submit a Question
        </base-button>
      </template>

      <div
        v-if="
          groupedQuestions &&
            (groupedQuestions.open.length >= 1 ||
              groupedQuestions.closed.length >= 1)
        "
      >
        <base-empty v-if="groupedQuestions.open.length < 1 && !showClosed">
          There are currently no questions.
          <br />
          <span v-if="UserHasPermission">
            Why not
            <router-link :to="{ name: 'QuestionCreate' }"
              >create one now</router-link
            >?
          </span>
        </base-empty>
        <question-item
          class="question-item"
          :key="question.id"
          v-for="question in groupedQuestions.open"
          :questionData="question"
          @click="onQuestionClick(question.id)"
          :showResponseCount="false"
        ></question-item>

        <question-item
          class="question-item"
          :key="question.id"
          v-for="question in groupedQuestions.closed"
          :questionData="question"
          @click="onQuestionClick(question.id)"
          :showResponseCount="false"
          v-if="showClosed"
        ></question-item>
      </div>

      <base-empty v-else>
        There are currently no questions.
        <br />
        <span v-if="UserHasPermission">
          Why not
          <router-link :to="{ name: 'QuestionCreate' }"
            >create one now</router-link
          >?
        </span>
      </base-empty>
    </section-block>
  </div>
</template>

<script>
import QuestionItem from "@/components/QuestionItem.vue";
import { mapState } from "vuex";
import { BaseEmpty } from "@/components/elements";
import UserHasPermission from "@/mixins/UserHasPermission";
import { mapGetters } from "vuex";
import { FormToggle } from "@/components/forms";
import querySearch from "@/mixins/querySearch";

export default {
  name: "collaboration",

  data() {
    return {
      loading: true,
      showClosed: false,
      showMoreFilters: false,
      sortOptions: [
        {
          label: "Newest First",
          field: "created_time",
          direction: "desc",
        },
        {
          label: "Oldest First",
          field: "created_time",
          direction: "asc",
        },
        {
          label: "Closing soon",
          field: "end_date",
          direction: "asc",
        },
      ],
    };
  },

  mounted() {},

  async created() {
    const { tabFilter } = this.$route.params;
    this.$store.commit("Questions/setTabFilter", tabFilter);
    await this.$store.dispatch("InterestGroups/list");
    this.$store.commit("Questions/setFilterCategories", []);

    this.setFiltersFromQuery("Questions");

    await this.$store.dispatch("Questions/list", tabFilter);
    this.loading = false;
  },

  computed: {
    ...mapGetters("Questions", ["groupedQuestions"]),
    ...mapState({
      interestGroups: (state) => state.InterestGroups.collection,
    }),
    filterGroups() {
      return this.userGroups.map((group) => ({
        id: group.id,
        name: group.name,
        meta: { members: 10 },
      }));
    },
    UserHasPermission() {
      return this.userHasPermission("add_edit_publish_questions");
    },
    tabs() {
      let tabs = [{ to: "/collaboration", title: "All questions" }];

      // If the user has permission to add questions, show the questions tab
      if (this.UserHasPermission) {
        tabs = [
          ...tabs,
          { to: "/collaboration/my-questions", title: "My questions" },
        ];
      }

      return tabs;
    },
  },

  methods: {
    onQuestionClick(questionId) {
      this.$router.push(`/collaboration/question/${questionId}`);
    },
  },

  mixins: [UserHasPermission, querySearch],

  components: {
    QuestionItem,
    BaseEmpty,
    FormToggle,
  },
};
</script>

<style lang="scss" scoped>
.sm-margin-neg {
  margin: -12px;

  @media (min-width: 1024px) {
    margin: auto;
  }
}

/deep/ .sm-margin-neg .c-filter-bar__control {
  margin-left: 0;
}
.p-collab-hub {
  &__extra {
    padding-top: 12px;
    @media screen and (min-width: 1024px) {
      display: none;

      &.is-shown {
        display: block;
      }
    }
  }

  .submit-button {
    position: fixed;
    bottom: 50px;
    bottom: calc(env(safe-area-inset-bottom) + 50px);
    left: 0;
    width: 100%;
    border-radius: 0;
    z-index: 10;

    @media (min-width: 640px) {
      position: relative;
      border-radius: 2em;
      width: auto;
      bottom: auto;
      left: auto;
    }
  }
}
</style>
